import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { MODULE_TRANSACTIONS_CONTAINER_TYPES,MODULE_TRANSACTIONS_FILTER_STATES } from 'src/constants/filters';

const TransactionsFilterBar = ({
  filterState,
  setFilterState,
  containerTypeFilter,
  setContainerTypeFilter,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div className="d-flex justify-content-between w-full transactions-filter-bar">
        <div className="btn-group me-3">
          {Object.values(MODULE_TRANSACTIONS_FILTER_STATES).map((state) => (
            <button
              key={state}
              type="button"
              className={`btn ${
                filterState === state 
                  ? 'module-transactions-btn-active' 
                  : 'module-transactions-btn'
              }`}
              aria-pressed={filterState === state}
              onClick={() => setFilterState(state)}
            >
              {state}
            </button>
          ))}
        </div>

        <Dropdown>
          <Dropdown.Toggle variant="outline-secondary" id="dropdown-container-type">
            Type: {containerTypeFilter}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {Object.entries(MODULE_TRANSACTIONS_CONTAINER_TYPES).map(([key, label]) => (
              <Dropdown.Item
                key={key}
                active={containerTypeFilter === label}
                onClick={() => setContainerTypeFilter(label)}
              >
                {label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

TransactionsFilterBar.propTypes = {
  filterState: PropTypes.string.isRequired,
  setFilterState: PropTypes.func.isRequired,
  containerTypeFilter: PropTypes.string.isRequired,
  setContainerTypeFilter: PropTypes.func.isRequired,
};

export default TransactionsFilterBar;
